import { IconButton, MenuItem, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OrderSearchAutocomplete from "../../../../Components/OrderSearchAutocomplete";
import Title from "../../../../Components/Title";
export default function OrderSection({ unedited, emaillist, setEmailList }) {
  unedited = unedited || emaillist;
  const { t } = useTranslation();
  const [resetKey, setResetKey] = useState("sdfasfsda");

  return (
    <Grid item sm={3} xs={12}>
      <Title>{t("emailLists.orders")}</Title>
      {unedited &&
        unedited.EmailListOrders &&
        unedited.EmailListOrders.map((u, i) =>
          u && u.Order ? (
            <MenuItem
              key={i}
              style={
                emaillist.EmailListOrders.find(
                  (uu) => uu.Order?.number === u.Order?.number
                )
                  ? {}
                  : { textDecoration: "line-through" }
              }
            >
              <Grid container direction="column">
                <Grid item>
                  <Typography style={{ fontSize: 15 }}>
                    {u.Order.number}
                  </Typography>
                </Grid>
                <Grid item container direction="row">
                  <Typography style={{ fontSize: 12 }}>
                    {u.Order.clientInfo.companyName}
                  </Typography>
                  <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                    {" "}
                    {u.Order.clientInfo.location}
                  </Typography>
                  <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                    {" "}
                    {u.Order.totalPrice} {u.Order.currency}
                  </Typography>
                </Grid>
              </Grid>
              <IconButton
                style={{ position: "absolute", right: 0 }}
                onClick={() => {
                  setEmailList({
                    ...emaillist,
                    EmailListOrders: emaillist.EmailListOrders.filter(
                      (f) => f.Order?.id !== u.Order?.id
                    ),
                  });
                }}
              >
                <Clear />
              </IconButton>
            </MenuItem>
          ) : null
        )}
      {emaillist &&
        unedited &&
        emaillist.EmailListOrders &&
        emaillist.EmailListOrders.filter(
          (u) =>
            !unedited.EmailListOrders.length ||
            !unedited.EmailListOrders.find((f) => u.Order?.id === f.Order?.id)
        ).map((u, i) => (
          <MenuItem
            key={i}
            style={{
              backgroundColor: "rgb(177 255 184)",
              fontSize: 15,
            }}
          >
            <Grid container direction="column">
              <Grid item>
                <Typography style={{ fontSize: 15 }}>
                  {u.Order.number}
                </Typography>
              </Grid>
              <Grid item container direction="row">
                <Typography style={{ fontSize: 12 }}>
                  {u.Order.clientInfo.companyName}
                </Typography>
                <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                  {" "}
                  {u.Order.clientInfo.location}
                </Typography>
                <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                  {" "}
                  {u.Order.totalPrice} {u.Order.currency}
                </Typography>
              </Grid>
            </Grid>
            <IconButton
              style={{ position: "absolute", right: 0 }}
              onClick={() => {
                setEmailList({
                  ...emaillist,
                  EmailListOrders: emaillist.EmailListOrders.filter(
                    (f) => f.Order?.id !== u.Order?.id
                  ),
                });
              }}
            >
              <Clear />
            </IconButton>
          </MenuItem>
        ))}
      <OrderSearchAutocomplete
        style={{ marginTop: 5 }}
        key={resetKey}
        additionalDataFields={[
          "clientInfo.companyName",
          "clientInfo.location",
          "totalPrice",
          "currency",
        ]}
        label={t("emailLists.searchOrder")}
        onChange={(e, v) => {
          if (!v || !v.number) {
            return;
          }
          setEmailList({
            ...emaillist,
            EmailListOrders: [
              ...(emaillist?.EmailListOrders || []),
              { Order: v },
            ],
          });
          setResetKey(new Date().toISOString());
        }}
      />
    </Grid>
  );
}
